export default __webpack_public_path__ + "static/media/vds-logo-de.dff75aba.jpg";